/**
 * Client and Server Shared Utility Functions
 * 
 * This file contains simple utility functions that are used by both
 * client-side (React components) and server-side (API routes) code.
 * 
 * IMPORTANT: Keep functions in this file simple and dependency-free.
 * Do NOT import client-only dependencies (like date-fns locales, i18n, etc.)
 * as this file is imported by serverless functions which will fail to bundle them.
 */

/**
 * Parse emails from comma, semicolon, or newline separated string
 * @param {string} input - Comma, semicolon, or newline separated email string
 * @returns {Array<string>} Array of valid, unique, normalized email addresses
 */
export function parseEmails(input) {
  if (!input || typeof input !== 'string') return [];

  // Split by comma, semicolon, or newline (handles both \n and \r\n)
  const emails = input.split(/[,;\r\n]+/)
    .map(email => email.trim())
    .filter(email => email.length > 0);
  
  // Validate format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validEmails = emails.filter(email => emailRegex.test(email));
  
  // Remove duplicates (case-insensitive) and normalize to lowercase
  const uniqueEmails = [...new Set(validEmails.map(e => e.toLowerCase()))];
  
  return uniqueEmails;
}
